import Vue from 'vue'
import Vuex from 'vuex'
import VueResource from 'vue-resource'
import {state} from './state'
import * as getters from './getters'
import * as mutations from './mutations'

import user from './modules/user';
import test from './modules/test';
Vue.use(Vuex);
Vue.use(VueResource);

Vue.http.options.credentials = true;

export const store = new Vuex.Store({
    modules: {
      user,
        test
    },
    state,
    getters,
    mutations
});




// WEBPACK FOOTER //
// ./src/store/index.js